import { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import { cn } from "../../utils/cn";
import logo from "../../assets/images/logo/hazer-logo.png";
import ProfileDropdown from "../ui/profile-dropdown";

const SharedDashboardLayout = ({ 
  sidebarLinks = [], 
  defaultRole
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-slate-900">
      {/* Header */}
      <header className="h-16 w-full border-b shadow-sm flex items-center px-4 dark:border-slate-700 dark:shadow-none dark:bg-slate-900 relative z-[1000]">
        <div className="flex items-center justify-between w-full">
          <Link to="/" className="flex items-center gap-2 ml-4">
            <img src={logo} alt="Hazer Logo" className="h-12 w-12 object-contain" />
            <h2 className="font-semibold text-lg text-gray-900 dark:text-gray-100">
              The Hazer Global, Pakistan
            </h2>
          </Link>

          <div className="flex items-center gap-4">

            <button
              type="button"
              onClick={() => setCollapsed((prev) => !prev)}
              className="hidden md:inline-flex items-center justify-center px-3 py-1.5 rounded-lg border border-[#EFA938] text-[#EFA938] font-semibold shadow-sm transition-colors hover:bg-[#FFF8EF] focus:outline-none focus:ring-2 focus:ring-[#EFA938]/40"
            >
              {collapsed ? "Expand" : "Collapse"}
            </button>

            {/* Profile dropdown */}
            <ProfileDropdown defaultRole={defaultRole} />
          </div>
        </div>
      </header>

      <div className="flex flex-1">
        {/* Sidebar */}
        <aside
          className={cn(
            "border-r shadow-md transition-all duration-300 bg-white dark:bg-slate-900 flex flex-col",
            "border-gray-200 dark:border-slate-700",
            collapsed ? "w-20" : "w-64"
          )}
        >
          <div className="flex flex-col h-full justify-between">
            <nav className="mt-6 space-y-1 px-3">
              {sidebarLinks.map((link) => {
                const Icon = link.icon;
                const isActive = location.pathname === link.href || (location.pathname === "/" && link.href === "/dashboard");
                
                return (
                  <Link
                    key={link.href}
                    to={link.disabled ? "#" : link.href}
                    onClick={(e) => {
                      if (link.disabled) e.preventDefault();
                    }}
                    className={cn(
                      "flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-all duration-200",
                      "text-gray-700 dark:text-gray-200",
                      !link.disabled && "hover:bg-[#FFF8EF] hover:text-[#EFA938] dark:hover:bg-slate-700 dark:hover:text-[#EFA938]",
                      isActive && !link.disabled && "bg-[#EFA938] text-white shadow-sm",
                      collapsed && "justify-center",
                      link.disabled && "opacity-50 cursor-not-allowed"
                    )}
                    aria-disabled={link.disabled}
                  >
                    <Icon className={cn("h-5 w-5", isActive && !link.disabled ? "text-white" : "text-[#EFA938]")} />
                    {!collapsed && <span className="text-sm font-medium">{link.title}</span>}
                    
                    {link.completed && !collapsed && (
                      <span className="ml-auto font-bold text-green-600 dark:text-green-400">
                        ✔
                      </span>
                    )}
                  </Link>
                );
              })}
            </nav>
          </div>
        </aside>

        {/* Main */}
        <main className="flex-1 px-4 md:px-8 py-6 text-gray-800 dark:text-gray-100 bg-gray-50 dark:bg-slate-900 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SharedDashboardLayout;
